// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page_8e565828 {
  position: relative;
  height: auto;
  display: grid;
  grid-auto-columns: auto 1fr;
  grid-template-areas: 'header header' 'sidebar main' 'sidebar footer';
  grid-template-rows: 4rem 1fr auto;
  padding: 0;
}
.page__header_8e565828 {
  position: sticky;
  top: 0;
  z-index: 80;
  display: flex;
  align-items: center;
  grid-area: header;
  width: 100%;
  height: 4rem;
  padding: 0 2rem;
  border-top: 0.084rem solid #eaedef;
  border-bottom: 0.084rem solid #eaedef;
  background: #f8f9fa;
}
.page__header_8e565828 .page__logo_8e565828 {
  width: 13.334rem;
  min-width: 13.334rem;
}
.page__header_8e565828 .page__logo_8e565828 a:hover {
  text-decoration: none;
}
.page__header_8e565828 .help-button_8e565828 {
  color: #11304d;
}
.page__logo_8e565828 {
  width: 17.334rem;
  min-width: 17.334rem;
  margin-right: 2rem;
}
.page__search_8e565828 {
  margin-right: 2rem;
}
.page__account-settings_8e565828 {
  flex-grow: 1;
}
.page__navbar_8e565828 {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  flex-grow: 1;
}
.page__main_8e565828 {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  min-width: 0;
  grid-area: main;
  height: 100%;
  position: relative;
}
.page__footer_8e565828 {
  flex-shrink: 0;
  text-align: center;
  padding-bottom: 2rem;
  padding-top: 2.667rem;
  font-family: PitchBookFont, 'Helvetica', 'Arial', sans-serif;
  font-size: 0.834rem;
  line-height: 1;
  letter-spacing: normal;
  font-stretch: normal;
}
.footer_8e565828 {
  grid-area: footer;
}
.footer__copyright_8e565828 {
  padding-bottom: 0.667rem;
}
.footer__links_8e565828 a {
  display: inline-block;
  margin: 0 0.667rem;
}
.footer__bvr_8e565828 {
  padding-top: 0.667rem;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `page_8e565828`,
	"page__header": `page__header_8e565828`,
	"page__logo": `page__logo_8e565828`,
	"help-button": `help-button_8e565828`,
	"page__search": `page__search_8e565828`,
	"page__account-settings": `page__account-settings_8e565828`,
	"page__navbar": `page__navbar_8e565828`,
	"page__main": `page__main_8e565828`,
	"page__footer": `page__footer_8e565828`,
	"footer": `footer_8e565828`,
	"footer__copyright": `footer__copyright_8e565828`,
	"footer__links": `footer__links_8e565828`,
	"footer__bvr": `footer__bvr_8e565828`
};
export default ___CSS_LOADER_EXPORT___;
